import { Injectable, inject } from '@angular/core';
import { ErrorResponse, MetadataDataService } from '@enp/platform-api-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { mapErrorResponseApiModelToStoreModel } from '@domain/common';
import { mapVersionApiModelToStoreModel } from '@domain/metadata';

import { CoreActions } from '@stores/core';

import { MetaDataActions } from './meta-data.actions';

@Injectable()
export class MetadataEffects {
  readonly #actions$ = inject(Actions);
  readonly #metadataDataService = inject(MetadataDataService);

  public getVersion$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(MetaDataActions.getVersion),
      switchMap(() =>
        this.#metadataDataService.getVersion().pipe(
          map((versions) =>
            MetaDataActions.getVersionSuccess({
              versions: mapVersionApiModelToStoreModel(versions),
            })
          ),
          catchError(({ error }: { error: ErrorResponse }) =>
            of(
              MetaDataActions.getVersionFail({
                errorMsg: mapErrorResponseApiModelToStoreModel(error),
              })
            )
          )
        )
      )
    );
  });

  public getVersionFail$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(MetaDataActions.getVersionFail),
      map(({ errorMsg }) => CoreActions.setErrorToastMessage({ toast: { message: errorMsg } }))
    );
  });
}
